"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base class for API services.
 */
class BaseApiService {
    /**
     * Fetches data from the specified URL.
     * @param url - The URL to fetch data from.
     * @param options - The options for the fetch request.
     * @returns A Promise that resolves to the response from the server.
     */
    async fetch(url, options) {
        return await fetch(url, options);
    }
}
exports.default = BaseApiService;
